export const SET_GUIDE_TOUR_SETTINGS = 'SET_GUIDE_TOUR_SETTINGS';
export const DELETE_GUIDE_TOUR_SETTINGS = 'DELETE_GUIDE_TOUR_SETTINGS';
